import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';

import GlobalContext from 'GlobalContext';

import IconComponent from 'components/shared/icon';
import ColorPicker from 'components/shared/color-picker';

import HeaderLogo from './TechTutzLogoComponent';

import './index.scss';

const navItems = [
  {
    to: '/home',
    label: 'Home',
    icon: 'IoHomeOutline',
    isActive: (path) => path === '/home',
  },
  {
    to: '/infobook',
    label: 'Infobook',
    icon: 'IoBookOutline',
    isActive: (path) => path.includes('infobook'),
  },
  {
    to: '/about',
    label: 'About',
    icon: 'IoInformationCircleOutline',
    isActive: (path) => path === '/about',
  },
];

const Header = () => {
  const location = useLocation();

  const {
    darkMode,
    setDarkMode,
    navExpanded,
    setNavExpanded,
    accentColor,
    setAccentColor,
  } = useContext(GlobalContext);

  const handleDarkModeToggle = () => setDarkMode(!darkMode);
  const handleNavToggle = () => setNavExpanded(!navExpanded);

  const iconColor = darkMode ? '#fff' : '#222';

  return (
    <header
      className={`${darkMode ? 'header-dark' : 'header'}${
        navExpanded ? '' : ' header-collapsed'
      }`}
    >
      <div className="header-top">
        <Link to="/home" className="header-logo-link">
          <HeaderLogo />
          {navExpanded && <span className="header-logo-text">TechTutz</span>}
        </Link>
        <button
          type="button"
          className="nav-toggle"
          onClick={handleNavToggle}
          aria-label={navExpanded ? 'Collapse navigation' : 'Expand navigation'}
        >
          <IconComponent
            size="18px"
            color={iconColor}
            iconName={navExpanded ? 'IoChevronBackOutline' : 'IoChevronForwardOutline'}
          />
        </button>
      </div>
      <nav className="nav" role="navigation">
        {navItems.map(({ to, label, icon, isActive }) => {
          const active = isActive(location.pathname);

          return (
            <Link
              key={to}
              to={to}
              className={`nav-link${active ? '-active' : ''}`}
            >
              <IconComponent
                size="22px"
                iconName={icon}
                color={active ? '#26e07f' : iconColor}
              />
              {navExpanded && <span className="nav-link-text">{label}</span>}
            </Link>
          );
        })}
      </nav>
      <div className="toggle-switch">
        <input
          type="checkbox"
          checked={darkMode}
          id="dark-mode-toggle"
          onChange={handleDarkModeToggle}
        />
        {navExpanded && (
          <label htmlFor="dark-mode-toggle">
            {darkMode ? 'Dark' : 'Light'} Mode
          </label>
        )}
      </div>
      {navExpanded && (
        <ColorPicker selectedColor={accentColor} onSelect={setAccentColor} />
      )}
    </header>
  );
};

export default Header;
